const PM_ITEM_PREFIX = 'pmb-method-item' as const;

export const DH = {
  Banner: 'payment-methods-banner',
  PaymentMethodView: {
    Logo: 'pmb-method-logo',
    Details: 'pmb-details-icon',
    ModalTrigger: 'pmb-modal-trigger',
    View: 'pmb-view',
  },
  PaymentMethodItem: {
    MethodPrefix: PM_ITEM_PREFIX,
    Laybuy: `${PM_ITEM_PREFIX}-laybuy`,
    Afterpay: `${PM_ITEM_PREFIX}-afteray`,
    Affirm: `${PM_ITEM_PREFIX}-affirm`,
    Clearpay: `${PM_ITEM_PREFIX}-clearpay`,
    Sezzle: `${PM_ITEM_PREFIX}-sezzle`,
    Atome: `${PM_ITEM_PREFIX}-atome`,
    CreditCard: `${PM_ITEM_PREFIX}-credit-card`,
    Generic: `${PM_ITEM_PREFIX}-generic`,
  },
} as const;
